<template>
  <a 
    class="pagination__prev" 
    :class = "(this.currentPage == 1) ? `pagination__prev-disabled`: ``"
    href="javascript:void(0);"
    v-on:click="prevPage()"
  >
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1202_4079)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0057 14.9951L17.5987 10.4021C17.6903 10.3086 17.7995 10.2342 17.92 10.1832C18.0405 10.1322 18.1699 10.1057 18.3007 10.105C18.4316 10.1043 18.5613 10.1296 18.6823 10.1794C18.8033 10.2292 18.9133 10.3024 19.0058 10.3949C19.0983 10.4875 19.1716 10.5974 19.2213 10.7184C19.2711 10.8395 19.2964 10.9691 19.2957 11.1C19.2951 11.2308 19.2685 11.3602 19.2175 11.4808C19.1665 11.6013 19.0921 11.7105 18.9987 11.8021L15.0987 15.7021L18.9987 19.6021C19.1812 19.7883 19.2829 20.0392 19.2816 20.3C19.2803 20.5608 19.1761 20.8106 18.9916 20.995C18.8072 21.1795 18.5574 21.2837 18.2966 21.285C18.0358 21.2863 17.785 21.1846 17.5987 21.0021L13.0057 16.4101C12.8182 16.2225 12.7129 15.9682 12.7129 15.7031C12.7129 15.4379 12.8182 15.1836 13.0057 14.9961V14.9951Z" />
        </g>
        <defs>
            <clipPath id="clip0_1202_4079">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
  </a>
  <ul class="pagination__list">
    <li 
      v-for="i, key in currentNumbersArray()"
      :key = key
    > 
      <a 
        :class = "(i == this.currentPage) ? 'current':''"
        v-on:click = "changePage(i)"
        href = "javascript:void(0);"
      >
        {{ i }}
      </a>
    </li>
  </ul>
  <a 
    class="pagination__next"
    :class = "(this.currentPage == this.getQtyPages) ? `pagination__next-disabled`: ``" 
    href="javascript:void(0);"
    v-on:click="nextPage()"
  >
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1202_4123)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9947 14.9951C19.1821 15.1826 19.2875 15.4369 19.2875 15.7021C19.2875 15.9672 19.1821 16.2215 18.9947 16.4091L14.4017 21.0021C14.2154 21.1846 13.9646 21.2863 13.7037 21.285C13.4429 21.2837 13.1932 21.1795 13.0087 20.995C12.8243 20.8106 12.7201 20.5608 12.7188 20.3C12.7174 20.0392 12.8191 19.7884 13.0017 19.6021L16.9017 15.7021L13.0017 11.8021C12.8191 11.6158 12.7174 11.365 12.7188 11.1041C12.7201 10.8433 12.8243 10.5935 13.0087 10.4091C13.1932 10.2247 13.4429 10.1205 13.7037 10.1192C13.9646 10.1178 14.2154 10.2195 14.4017 10.4021L18.9947 14.9951Z" />
        </g>
        <defs>
            <clipPath id="clip0_1202_4123">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
  </a>
</template>

<script>
 import { mapGetters, mapState, mapActions } from "vuex";
  export default {
    name: "ListDTPagination",
    computed: {
      ...mapState("ListDT", ["currentPage"]),
      ...mapGetters("ListDT", ["sidebarDTCount", "getQtyPages"]),
    }, 
    methods: {
      ...mapActions("ListDT", ["changeCurrentPage"]),
      nextPage() {
        let value = this.currentPage;
        if ( value < this.getQtyPages ) {
          value ++;
          this.changePage(value)
        }
      },
      prevPage() {
        let value = this.currentPage;
        if ( value > 1 ) {
          value --;
          this.changePage(value)
        }
      },
      changePage(value) {
        if (value != "...") {
          this.changeCurrentPage(value)
        }
        
      },
      currentNumbersArray() {
        const countPage = this.getQtyPages;
        const page = this.currentPage;
        let resArr = []
        if (countPage <=6 ) {
          for (let i = 0; i < countPage; i++) {
            resArr[i] = `${i+1}`
          }
          return resArr
        }
        if (page < 5 ) {
          for (let i = 0; i < 5; i++) {
            resArr[i] = `${i+1}`
          }
          resArr[5] = "...";
          resArr[6] = countPage;
          return resArr
        }
        if (page >= 5 && page <= countPage - 4) {
          resArr[0] = "1";
          resArr[1]="...";
          resArr[2]= page - 1;
          resArr[3]= page;
          resArr[4]= Number(page) + 1;
          resArr[5] = "...";
          resArr[6] = countPage;
          return resArr
        }
        if (page > countPage - 4) {
          resArr[0] = "1";
          resArr[1]="...";
          for (let i = 0; i < 5; i++) {
            resArr[6 -i] = countPage - i;
          }
          return resArr
        }
      }
    }
  }
</script>